export default "__VITE_ASSET__2955d3e9__"